<app-top-navbar/>
<div class="wrapper page-login">
  <app-loyalty-club-header [customHTML]="true"/>
  @if ((settings$ | async)?.login_enabled) {
    <div class="content">
      @if ((isHybridLogin$ | async)) {
        <router-outlet/>
      } @else {
        <app-login/>
      }
    </div>
  } @else {
    <div class="content text-center">
      <h4>{{ 'login.login_disabled' | translate }}</h4>
    </div>
  }
  <app-loyalty-club-footer/>
</div>
